import { defineCss } from '@src/style/style';
import { makeButton } from './networkHelpers.js';

// START
/* Hidding as not usefull without auto setup
const lTooltips = {
    connecting_multiple_controllers: {
      title: 'Connecting Multiple Controllers',
      images: ['/multi_controllers.png'],
      description: [
        $('<div>').append(
          $.parseHTML(
            'The order of the controller names are numbered in the order as the figure shown below. Auto-setup will manually detect this order.' +
            '<br><br>' +
            'To configure a manual-setup, connect a PC or pendant into each individual controller to set up the network.'
          )
        )
      ]
    },

    identify_machinemotion_controllers: {
      title: 'Identify MachineMotion Controllers',
      images: ['/multi_controllers.png'],
      hide_glossary: true,
      description: [
        $('<div>').append(
          $.parseHTML('The orders of the controllers are in the same order that your controllers are connected to each other.')
        )
      ]
    }
};

// heavily inspired by configChechers tootlip, but standalone
function showTool(pTooltip) {
    var lModalContainer = $('<div class="ml_modal_container">');
    var lModal = $('<div>')
        .css({
            'display': 'flex', 'flex-direction': 'column', 'align-items': 'center',
            'position': 'absolute',
            'width': '730px',
            'padding': '8px',
            'border-radius': '4px',
            'background-color': 'white',
            'box-shadow': '0px 4px 14px rgba(0, 0, 0, 0.2)',
            'overflow': 'hidden',
        })
        .appendTo(lModalContainer);

    var lCloseBtn = $('<div class="fas fa-times">')
        .css({ position: 'absolute', top: '4px', right: '6px', color: '#E2E2E2', cursor: 'pointer' })
        .click(() => { lModalContainer.remove(); })
        .appendTo(lModal);

    $('<div>')
        .text(`${pTooltip.title}`)
        .appendTo(lModal)
        .css({
            "font-weight": "bold", "font-size": "24px",
            "line-height": "29px",
            "margin-top": "15px", "margin-bottom": "10px"
        });

    lModal.append(
        pTooltip.description.map( desc => desc.css({ "textAlign": 'center', "font-size": "14px", "line-height": "17px" }))
    );

    var lImages = $('<div>').css({display: 'flex', justifyContent: 'space-evenly', width: '100%', margin: '20px 0px'}).appendTo(lModal);
    pTooltip.images.forEach(img => {
        $('<img>').attr('src', `/images/tooltip${img}`).css({ height: '230px', background: 'grey'}).appendTo(lImages);
    })

    $('body').append(lModalContainer);
}
// END
Hidding as not usefull without auto setup */

const controllerApp = {
  rightPane: null,
  uiLeft: null,
  uiRight: null,
  apps: null,
  selected: false,
  controllers: [], /* in the form of: { "versionNumber": "parent","ipAddress":"N/A","hardwareVersion":"hw","softwareVersion":"sw" } */
  name: 'MachineMotion Controllers',
  controllerNameMap: {}, /* in the form of : { uuid1: { name:"SomeName", parent:true }, uuid2: { name:"SomeOtherName", parent:false } } */

  init: function (pLeft, pRight, pApps, callbacksMap) {
    this.apps = pApps;
    this.rightPane = pRight;
    this.uiLeft = makeButton(this.name, false);
    pLeft.append(this.uiLeft);

    this.getDetectedNetworks = callbacksMap.getDetectedNetworks;

    this.uiLeft.find('.app-button-title').click(() => {
      this.apps.select(this.name);
      if (this.getDetectedNetworks) { this.getDetectedNetworks(); }
    });
  },

  makeRightUI: function (controller, index = undefined) {
    defineCss('.controllers:not(:first-child)', 'padding-top: 10px;');
    defineCss('.controllers:not(:last-child)', 'border-bottom: 1px solid #E2E2E2;');
    defineCss('.controller-header', 'display: flex; justify-content: space-between; padding: 5px 0 10px 0;');
    defineCss('.controller-configs', 'display: flex; flex-direction: column;');
    defineCss('.controller-configs > div:last-child', 'padding-bottom: 10px;');
    defineCss('.controller-configs > div:first-child', 'padding-bottom: 4px; color: #88979B;');

    let name = '';
    const namedController = this.controllerNameMap[controller.configControllerUuid];
    if (namedController) {
      // The controller's IP address was found in the config.
      name = namedController.name;
      if (Object.keys(this.controllerNameMap).length > 1) {
        name = name + ' ' + (namedController.parent ? '(Parent)' : '(Child)');
      }
    }
    else if (this.controllers.length == 1 && Object.keys(this.controllerNameMap).length == 1) {
      // There is only one detected controller, and only one configured controller.
      name = Object.values(this.controllerNameMap)[0].name;
    }
    else {
      // There is more than one detected or configured controller.
      name = `Not configured MachineMotion #${index}`;
    }

    const ui = $('<div class="controllers">')
      .append(
        $('<div class="controller-header">').append(
          $('<div class="network-bold">').text(`${name}`),
          $('<div>')
            .css({ color: '#88979B', 'font-size': '16px', 'padding-right': '10px' })
            .text(`SW ${controller.softwareVersion} & HW ${controller.hardwareVersion.replace(/-1D$/, ' ONE-DRIVE')}`),
        ),
        $('<div class="controller-configs">').append(
          $('<div>').text('IP Addresses:'),
          ...controller.ipAddresses.map(ip => $('<div>').text(ip)),
        ),
      );
    return ui;
  },

  show: function () {
    if (!this.selected) { return; }

    const ui = $('<div class="app-right app-right-full-container">').append(
      $('<div class="app-right app-right-full-inner">').append(
        $('<div class="network-bold center-column bigger">').text('Detected MachineMotion Controllers'),
        $('<div class="scrollbar">')
          .css({
            'background-color': 'white',
            border: '1px solid #E2E2E2',
            'border-radius': '5px',
            padding: '10px',
            // scroll
            overflow: 'hidden',
            'overflow-y': 'auto',
            'max-height': '100%',
          })
          .append([...this.controllers].filter(controller => this.controllerNameMap[controller.configControllerUuid]).map((controller) => this.makeRightUI(controller)))
          .append([...this.controllers].filter(controller => !this.controllerNameMap[controller.configControllerUuid]).map((controller, index) => this.makeRightUI(controller, index + 1))),
      ),
    );

    /* Hidding as not usefull without auto setup
        if(this.controllers.length) {
            ui.append(
                $('<div>').css({
                    'display': 'flex', 'justify-content': 'center', 'align-items': 'baseline',
                    'gap': '10px',
                    'color': '#A1A1A1',
                    'cursor': 'pointer',
                    'font-size': '16px',
                    'height': '2rem',
                })
                .click(function() { showTool(lTooltips['identify_machinemotion_controllers']); })
                .append(
                    $('<div>').text('Identifying MachineMotion controllers'),
                    $('<div class="ml_tooltip_icon ml_label_icon icon-help">')
                )
            );
        }
        */

    this.rightPane.empty();
    this.uiRight = ui;
    this.rightPane.append(this.uiRight);
  },

  update: function (type, data) {
    switch (type) {
      case 'onDiscovered':
        this.controllers = data;
        this.show();
        break;
      case 'onControllersName':
        this.controllerNameMap = data;
        this.show();
        break;
      default: break;
    }
  },

  _remove: function () {
    if (this.uiRight) {
      this.uiRight.remove();
      this.uiRight = null;
    }
  },

  select: function () {
    this.selected = true;
    this.uiLeft.addClass('selected');
    this.uiLeft.find('.app-button-title').addClass('selected');
    this.show();
  },

  deselect: function () {
    this.selected = false;
    this._remove();
    this.uiLeft.removeClass('selected');
    this.uiLeft.find('.app-button-title').removeClass('selected');
  },
};

export default controllerApp;
